import React from 'react';
import styled from 'styled-components';
import { IoIosClose } from 'react-icons/io';
import { timeValueToDate, inputNumberAutoComma } from '../../lib/commonFunc/commonFunc';
import palette from '../../lib/styles/palette';

const FullScreen = styled.div`
  position: fixed;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const AskModalBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 560px;
  max-width: 92vw;
  background: #fff;
  padding: 24px 28px 26px;
  border-radius: 16px;
  max-height: 78vh;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);

  @media screen and (max-width: 720px) {
    position: absolute;
    top: 120px;
  }
`;

const CloseBlock = styled.div`
  position: absolute;
  top: 18px;
  right: 20px;
  & svg {
    cursor: pointer;
    font-size: 1.9rem !important;
    color: #b0b8c4;
  }
  & svg:hover { color: #6b7280; }
`;

const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin: 34px 0 4px;
  padding-bottom: 16px;
  border-bottom: 2px solid #eef0f3;
  .ttl { font-size: 1.15rem; font-weight: 800; color: #2c3e50; }
  .sum { font-size: 1.35rem; font-weight: 800; color: ${palette.webCyan[5]}; letter-spacing: -0.5px; }
`;

const List = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-right: -16px;
  padding-right: 16px;
  &::-webkit-scrollbar { width: 8px; }
  &::-webkit-scrollbar-thumb {
    background-color: ${palette.webGray[4]};
    border-radius: 10px;
    background-clip: padding-box;
    border: 2px solid transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: ${palette.webGray[2]};
    border-radius: 10px;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  & + & { border-top: 1px solid #f2f4f7; }
  .type { flex: 1; text-align: left; font-size: .96rem; font-weight: 600; color: #3a4656; }
  .date { flex-shrink: 0; margin: 0 16px; text-align: left; font-size: .9rem; color: #868e96; white-space: nowrap; }
  .amt { flex-shrink: 0; text-align: right; font-size: .96rem; font-weight: 700; color: #3a4656; white-space: nowrap; }
`;

const Empty = styled.div`
  padding: 40px 0;
  text-align: center;
  color: #adb5bd;
  font-size: .95rem;
`;

const PointInfoModal = ({
  visible,
  onClose,
  data,
}) => {
    const getDecreaseTypeString = (useData)=>{
        switch (useData.fcType) {
            case 0:
                return useData.memo?useData.memo:'이벤트';
            case 102:
                return '회원권';
            case 103:
                return useData.memo?`락커 - ${useData.memo}`:'락커';
            case 104:
                return '일반 상품';
            default:
                return '';
        }
    }
  if (!visible) return null;

  const isEventType = (dd) => dd.fcType == 0 || dd.fcType == 102 || dd.fcType == 103 || dd.fcType == 104;
  const total = (data && Array.isArray(data.infos) ? data.infos : []).reduce(
    (sum, dd) => (dd.action == 1 && isEventType(dd) ? sum + dd.point : sum), 0,
  );
  const rows = (data && Array.isArray(data.infos) ? data.infos : []).filter(
    (dd) => dd.action != 2 && isEventType(dd),
  );

  return (
    <FullScreen>
      <AskModalBlock>
        <CloseBlock>
          <IoIosClose onClick={() => onClose()} />
        </CloseBlock>
        <Head>
          <span className="ttl">이벤트 획득</span>
          <span className="sum">{inputNumberAutoComma(total)}원</span>
        </Head>
        <List>
          {rows.length ? rows.map((useData, index) => (
            <Row key={index}>
              <span className="type">{getDecreaseTypeString(useData)}</span>
              <span className="date">{timeValueToDate(useData.registTime)}</span>
              <span className="amt">{inputNumberAutoComma(useData.point)}원</span>
            </Row>
          )) : <Empty>이벤트 획득 내역이 없습니다.</Empty>}
        </List>
      </AskModalBlock>
    </FullScreen>
  );
};

export default PointInfoModal;
